import { useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useGetApplications } from '@/hooks';
import ApplicationsList from "@/components/applications/applications-list";

const AdminCompletedApplicationsPage = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data: responseData, isLoading, isError } = useGetApplications(
    'completed',
    true,
    { page, limit: 20, search: search || undefined }
  );

  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ApplicationsList
      data={data}
      isLoading={isLoading}
      isError={isError}
      title={t('processManagement.allCompletedApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.errorOccurredWhileFetchingCompletedApplications')}
      searchPlaceholder={t('processManagement.search')}
      baseRoute="/admin/management/completed-applications"
      noDataMessage={t('processManagement.noCompletedApplicationsFound')}
      meta={meta}
      search={search}
      onSearchChange={handleSearchChange}
      onPageChange={setPage}
    />
  );
};

export default AdminCompletedApplicationsPage;